<template>
  <div id="appointment-status-history">
    <div class="d-flex align-items-center justify-content-between mb-5">
      <h4 class="mb-0">{{$t('homelab.labels.appointment_status_history')}}</h4>
      <va-popover
          class="clickable"
          v-if="hasWriteAppointmentsPermissions"
          placement="left"
          :message="$t('homelab.buttons.update_status')">
        <span @click.prevent="isUpdatingAppointmentStatus = true">
          <i class="glyphicon glyphicon-plus px-3 mr-3"></i>
        </span>
      </va-popover>
    </div>

    <div class="row">
      <v-client-table
        id="filesTable"
        ref="filesTable"
        :columns="tableColumns"
        :data="appointment.status_history"
        :options="tableOptions"
        class="col"
      >
        <template slot="date" slot-scope="{ row }">
          <span>{{ row.date | localTime('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="status" slot-scope="{ row }">
          <span>{{$t(`homelab.statuses.${row.status.id}`)}}</span>
        </template>
        <template slot="scheduled_time" slot-scope="{ row }">
          <span>{{getFormatedScheduledTime(row.scheduled_time_start, row.scheduled_time_end)}}</span>
        </template>
        <template slot="updated_by" slot-scope="{ row }">
          <span>{{row.updated_by ? row.updated_by.name : $t('homelab.labels.by_app_user')}}</span>
        </template>
      </v-client-table>
    </div>

    <UpdateAppointmentStatus
      v-if="isUpdatingAppointmentStatus"
      :appointment="appointment"
      @appointment-status-updated="onAppointmentStatusUpdated"
      @cancel="isUpdatingAppointmentStatus = false"
    />
  </div>

</template>

<script>
import UpdateAppointmentStatus from '@/components/homelab/appointments/UpdateAppointmentStatus'
export default {
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  components: {
    UpdateAppointmentStatus
  },
  computed: {
    homelabService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.homelab_server)
    },
    hasWriteAppointmentsPermissions: function () {
      return this.homelabService && this.appointment && this.homelabService.user_permissions.some(permission => (permission.entity_id === null || permission.entity_id === this.appointment.entity.id) && permission.access_type > 1 && permission.info_type === 100)
    }
  },
  data: function () {
    return {
      isUpdatingAppointmentStatus: false,
      tableColumns: ['date', 'status', 'scheduled_time', 'private_commentary', 'public_commentary', 'updated_by'],
      tableOptions: {
        texts: {
          count: this.$t('tables.records') + ' {from} ' + this.$t('tables.to') + ' {to} ' + this.$t('tables.of') + ' {count}|{count} ' + this.$t('tables.records_') + '|' + this.$t('tables.one_record'),
          first: this.$t('tables.first'),
          last: this.$t('tables.last'),
          filter: this.$t('tables.filter') + ':',
          filterPlaceholder: this.$t('tables.search_text'),
          limit: this.$t('tables.records') + ':',
          page: this.$t('tables.page') + ':',
          noResults: this.$t('tables.no_records'),
          filterBy: this.$t('tables.filter_by') + ' {column}',
          loading: this.$t('tables.loading') + '...',
          defaultOption: this.$t('tables.select') + ' {column}',
          columns: this.$t('tables.columns_dropdown')
        },
        sortable: [],
        filterable: false,
        headings: {
          'date': this.$t('homelab.labels.status_date'),
          'status': this.$t('homelab.labels.status'),
          'scheduled_time': this.$t('homelab.labels.scheduled_time'),
          'private_commentary': this.$t('homelab.labels.private_commentary'),
          'public_commentary': this.$t('homelab.labels.public_commentary'),
          'updated_by': this.$t('homelab.labels.by')
        },
        columnsClasses: {
          private_commentary: 'private_commentary',
          public_commentary: 'public_commentary',
          updated_by: 'updated_by'
        },
        pagination: {
          chunk: 6,
          nav: 'scroll'
        }
      }
    }
  },
  methods: {
    getFormatedScheduledTime: function (start, end) {
      if (start && end) {
        start = this.moment(this.$options.filters.localTime(start, 'YYYY-MM-DD HH:mm:ss', '', this.locale))
        end = this.moment(this.$options.filters.localTime(end, 'YYYY-MM-DD HH:mm:ss', '', this.locale))
        return `${start.format('YYYY-MM-DD')} ${this.$t('date_helpers.hour_from')} ${start.format('HH:mm')} ${this.$t('date_helpers.hour_to')} ${end.format('HH:mm')}`
      } else {
        return this.$t('homelab.unassigned')
      }
    },
    onAppointmentStatusUpdated: function (payload) {
      this.$emit('appointment-status-updated', payload)
    },
  }
}
</script>

<style lang="scss">
  #appointment-status-history {
    .table-bordered th, .table-bordered td {
      border: 0 !important;
    }
    td.updated_by {
      width: 15%;
    }
  }
</style>
